import React from 'react'
import { Container , Row , Col, Form, FormGroup } from 'reactstrap'
import Helmet from '../components/helmet/Helmet'
import ShopSection from "../components/ui/ShopSection"
import { useSelector } from 'react-redux'



import "../style/checkout.css"

const Checkout = () => {

const totalQty = useSelector(state => state.cart.totalQuantity);
const totalAmount = useSelector(state => state.cart.totalAmount);


  return (
		<Helmet title="Checkout">
			<ShopSection title="Checkout" />

			<section>
				<Container>
					<Row>
						<Col lg="8">
							<h6 className="mb-4 fw-bold">Billing Information</h6>
							<Form className="billing__form">
								<FormGroup className="form__group">
									<input type="text" placeholder="Enter your name" className='w-100'/>
								</FormGroup>
								<FormGroup className="form__group">
									<input type="email" placeholder="Enter your email" className='w-100' />
								</FormGroup>
								<FormGroup className="form__group">
									<input type="number" placeholder="Phone Number"  className='w-100'/>
								</FormGroup>
								<FormGroup className="form__group">
									<input type="text" placeholder="Street address"  className='w-100'/>
								</FormGroup>

								<FormGroup className="form__group">
									<input type="text" placeholder="City" className='w-100' />
								</FormGroup>
								<FormGroup className="form__group">
									<input type="text" placeholder="Postal Code"  className='w-100'/>
								</FormGroup>
								<FormGroup className="form__group">
									<input type="text" placeholder="Country" className='w-100' />
								</FormGroup>
							</Form>
						</Col>
						<Col lg="4">
							<div className="checkout__cart">
								<h6>
									Total Qty:<span>{totalQty} items</span>
								</h6>
								<h6>
									Subtotal :<span>${totalAmount}</span>
								</h6>
								<h6>
									<span>
										Shipping :<br /> free shopping{" "}
									</span>
									<span>$1</span>
								</h6>
								{/* <h6>Free shipping</h6> */}
								<h4>
									Total Cost: <span>${totalAmount}</span>
								</h4>
								<button className="buy__btn auth__btn w-100">
									Place an order
								</button>
							</div>
						</Col>
					</Row>
				</Container>
			</section>
		</Helmet>
	);
}

export default Checkout